import { Box, Text, Timeline } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { StatusAlertFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { ElementStatus } from '../../../../..';
import { HeadingStructureRuleGenericCompletedStateNoTimeline } from './heading-structure-rule-generic-completed-state-no-timeline';
import { HeadingStructureRuleGenericCompletedStateWithTimeline } from './heading-structure-rule-generic-completed-state-with-timeline';
export const HeadingStructureRuleGenericTimeline = _ref => {
  let {
    status,
    failedReason,
    texts,
    transComponents = {}
  } = _ref;
  const failedItems = texts.timeline.failedByReason[failedReason];
  const passedItems = texts.timeline.success;
  const shouldShowTimelineOnSuccess = passedItems !== undefined;
  const mergedComponents = {
    bold: /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "bold"
    }),
    ...transComponents
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, status === ElementStatus.Failed ? /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "0 SP2 SP2 SP2"
  }, /*#__PURE__*/React.createElement(Timeline, {
    items: [{
      customPrefix: /*#__PURE__*/React.createElement(Box, {
        color: "R10"
      }, /*#__PURE__*/React.createElement(StatusAlertFilledSmall, {
        size: "18px"
      })),
      label: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        skin: "error",
        weight: "normal"
      }, texts.errorMessageByReason[failedReason])
    }]
  }), /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: failedItems.map((content, idx) => ({
      key: `failed-${idx}`,
      label: /*#__PURE__*/React.createElement(Text, {
        size: "tiny"
      }, /*#__PURE__*/React.createElement(Trans, {
        components: mergedComponents
      }, content))
    })),
    skin: "dark"
  })) : shouldShowTimelineOnSuccess ? /*#__PURE__*/React.createElement(HeadingStructureRuleGenericCompletedStateWithTimeline, {
    mergedComponents: mergedComponents,
    passedItems: passedItems,
    texts: texts
  }) : /*#__PURE__*/React.createElement(HeadingStructureRuleGenericCompletedStateNoTimeline, {
    text: texts.successMessage
  }));
};
//# sourceMappingURL=heading-structure-rule-generic-timeline.js.map